import { queryOptions } from "@tanstack/react-query"
import axios from "axios"
import {
  CreditTransactionsResponseDataSchema,
  DataResponseWithPagination,
  GetCreditTransactionsSchema,
} from "schema"
import { z } from "zod"

type Response = DataResponseWithPagination<z.infer<typeof CreditTransactionsResponseDataSchema>>
type Query = z.infer<typeof GetCreditTransactionsSchema>
type OnSuccessFn = (data: Response) => void

type Props = {
  query?: Query
  onSuccess?: OnSuccessFn
}

const getCreditTransactionsQueryKey = () => ["credit-transactions"]

export const creditTransactionsQuery = ({ query, onSuccess }: Props = {}) => {
  return queryOptions({
    queryKey: getCreditTransactionsQueryKey(),
    queryFn: async () => {
      const { data } = await axios.get<Response>("/billing/credit-transactions", {
        params: query,
      })
      onSuccess?.(data)
      return data.data
    },
  })
}
